module.exports = __webpack_public_path__ + "img/logo.7f8a5665.svg";